const capitalizeFirstLetter = (value: string | null | undefined): string => {
  if (value == null) {
    return '';
  }

  if (!value.length) {
    return value;
  }

  return `${value[0].toUpperCase()}${value.slice(1)}`;
};

export default capitalizeFirstLetter;
